export const Results = () => {
	return (
		<>
			<h1>Results</h1>
		</>
	);
}